import React from 'react'
import { BarChart } from 'components/BarChart'
import { Link } from '@ta-interaktiv/contentbricks'

export const GRAPHS: { [key: string]: JSX.Element } = {
  Moderna: (
    <BarChart
      key='moderna'
      title='Nebenwirkungen bei Moderna'
      sub={<>Daten aus der letzten klinischen Prüfphase III.</>}
      colorkey={[
        { name: '1. Dosis', color: '#DCD8C9' },
        { name: '2. Dosis', color: '#202346' }
      ]}
      unit='%'
      data={[
        { name: 'Schmerz an der Einstichstelle', values: [86.9, 90.1] },
        { name: 'Müdigkeit', values: [38.5, 67.6] },
        { name: 'Kopfschmerz', values: [35.4, 62.8] },
        { name: 'Muskelschmerzen', values: [23.7, 61.3] },
        { name: 'Gelenkschmerzen', values: [16.6, 45.2] },
        { name: 'Vergrösserte Lymphknoten', values: [11.6, 16] },
        { name: 'Schwindel und Erbrechen', values: [9.4, 21.3] },
        { name: 'Schüttelfrost', values: [9.2, 48.3] },
        { name: 'Schwellungen', values: [6.7, 12.6] },
        { name: 'Hautrötungen', values: [3, 9] },
        { name: 'Fieber', values: [0.9, 17.4] }
      ]}
      source={
        <>
          <Link href='https://www.fda.gov/media/144434/download'>Moderna</Link>
        </>
      }
    />
  ),
  Pfizer: (
    <BarChart
      key='pfizer'
      title='Nebenwirkungen bei Pfizer/Biontech'
      sub={<>Daten aus der letzten klinischen Prüfphase III.</>}
      unit='%'
      colorkey={[
        { name: '1. Dosis', color: '#DCD8C9' },
        { name: '2. Dosis', color: '#202346' }
      ]}
      data={[
        { name: 'Schmerz an der Einstichstelle', values: [83.1, 77.8] },
        { name: 'Müdigkeit', values: [47.4, 59.4] },
        { name: 'Kopfschmerz', values: [41.9, 51.7] },
        { name: 'Neuer/Stärkerer Muskelschmerz', values: [21.3, 37.3] },
        { name: 'Schüttelfrost', values: [14, 35.1] },
        { name: 'Durchfall', values: [11.1, 10.4] },
        {
          name: 'Neue/Stärkere Gliederschmerzen',
          values: [11, 21.9]
        },
        { name: 'Schwellungen', values: [5.8, 6.3] },
        { name: 'Hautrötungen', values: [4.5, 5.9] },
        { name: 'Fieber', values: [3.7, 15.8] },
        { name: 'Erbrechen', values: [1.2, 1.9] }
      ]}
      source={<>Pfizer</>}
    />
  )
}
